import BaseComponent from '../../js/base-component';
import contentBlocker from '../../js/content-blocker';
import getScript from '../../js/get-script';

export default class HeaderComponent extends BaseComponent {
    constructor(...args) {
        super(...args);

        //this.lens = this.refs.lens;
        this.trigger = this.refs.trigger;
        this.menu = this.refs.menu;
        //this.search = this.refs.search;
        this.loader = this.refs.loader;
        //this.close = this.refs.close;
        this.navclose = this.refs.navclose;
        this.body = document.body;

        this.OpenedClass = 'is-opened';
        this.InitedClass = 'is-inited';
        this.NotInitedClass = 'not-inited';

        //this.onSearchFirstTrigger = this.onSearchFirstTrigger.bind(this);
        this.onTriggerClick = this.onTriggerClick.bind(this);
        //this.onSearchTriggerClick = this.onSearchTriggerClick.bind(this);
       // this.onSearchCloseClick = this.onSearchCloseClick.bind(this);
        this.onNavCloseClick = this.onNavCloseClick.bind(this);
        //this.loadSearch = this.loadSearch.bind(this);
        this.isSticky = this.isSticky.bind(this);
    }

    static getRequiredRefs(){
        return ['trigger', 'menu', 'navclose'];
    }

    init(){
        //setTimeout(this.onSearchFirstTrigger, 3500);
        //this.loader.addEventListener('click', this.onSearchFirstTrigger);
        this.trigger.addEventListener('click', this.onTriggerClick);
        //this.lens.addEventListener('click', this.onSearchTriggerClick);
        //this.close.addEventListener('click', this.onSearchCloseClick);
        this.navclose.addEventListener('click', this.onNavCloseClick);
        //document.addEventListener('click', e => this.clickOutSide(e));
        window.addEventListener("scroll", e => this.isSticky(e));
    }

    isSticky(e){
        if(+window.scrollY > 0) {
            this.element.classList.add("is-sticky");
        }
        else {
            this.element.classList.remove("is-sticky");
        }
    }

/*    clickOutSide(event) {
        const isClickInside = this.search.contains(event.target)

        if (!isClickInside) {
            this.search.classList.add('google-search--hidden');
        } else {
            this.search.classList.remove('google-search--hidden');
        }
    }*/

    onTriggerClick(e){
        //this.onSearchFirstTrigger();
        //this.search.classList.add('skeleton');
        this.menu.classList.toggle(this.OpenedClass);
        this.trigger.classList.toggle(this.OpenedClass);
        if(contentBlocker.isBlocked('header')){
            contentBlocker.unblock('header');
        }else {
            contentBlocker.block('header');
        }

/*        if(this.search.classList.contains(this.OpenedClass)){
            this.search.classList.remove(this.OpenedClass);
            this.lens.classList.remove(this.OpenedClass);
        }*/
    }

    onNavCloseClick(e){
        this.menu.classList.remove(this.OpenedClass);
        contentBlocker.unblock('header');
        //this.search.classList.remove(this.OpenedClass);
    }

/*    loadSearch(){
        this.search.classList.add(this.InitedClass);
        this.search.classList.remove('skeleton');
        window.__gcse = {
            parsetags: 'onload',
            initializationCallback: function() {
                let placeholder = ct_lang == 'ru' ? 'Поиск' : 'Search';
                let inputField = document.querySelector("input.gsc-input");
                inputField.placeholder = placeholder;
                inputField.removeAttribute('style');
            }
        }
    }*/

/*    getSearchScript(){
        let scriptSrc = 'https://cse.google.com/cse.js?cx=' + scriptPostSrc;
        getScript(scriptSrc)
            .then(() => {
                setTimeout(() => {
                    this.loadSearch();
                }, 0);
            })
            .catch(() => {
                console.error('Could not load google search')
            })
    }*/

/*    onSearchTriggerClick(e){
        this.onSearchFirstTrigger();
        this.search.classList.toggle(this.OpenedClass);
        if(this.menu.classList.contains(this.OpenedClass)){
            this.menu.classList.remove(this.OpenedClass);
            this.trigger.classList.remove(this.OpenedClass);
        }
        contentBlocker.block('header');
    }

    onSearchFirstTrigger(){
        if(this.search.classList.contains(this.NotInitedClass)){
            this.getSearchScript();
            this.search.classList.remove(this.NotInitedClass);
        }
    }*/

/*    onSearchCloseClick(e){
        this.search.classList.toggle(this.OpenedClass);
        contentBlocker.unblock('header');
    }*/

    onDestroy(){
        //this.loading.removeEventListener('click', this.onSearchFirstTrigger);
        this.trigger.removeEventListener('click', this.onTriggerClick);
        //this.lens.removeEventListener('click', this.onSearchTriggerClick);
        //this.close.removeEventListener('click', this.onSearchCloseClick);
       // document.removeEventListener('click', e => this.clickOutSide(e));
        window.removeEventListener("scroll", e => this.isSticky(e));
    }
}
